// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".horizontal-tabs .horizontal-tab-hidden{display:block;visibility:hidden;height:0}.horizontal-tabs .horizontal-tabs-active-tab{width:100%!important;height:auto!important;display:block;visibility:visible}", ""]);
// Exports
module.exports = exports;
